import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/RE4/banner_back.webp";
import { Link } from "gatsby";

function Banner() {
  return (
    <section
      className="banner_h100 smartid_banner banner_re4"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h1 style={{ color: "#fff" }}>RE4 Sale Signs</h1>
            <p style={{ color: "#fff" }}>
              A unique remote real estate engagement solution for real estate
              agents and sign installers to collaborate and get the job done.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Get Inspired
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
